/**
 * Returns whether a Shopify integration represents a real customer store.
 * Demo stores are exploration-only, regardless of connection or membership
 * state.
 */
export const isRealStore = (store) => Boolean(store) && store.isDemo !== true;

/** Returns whether an accessible Shopify store list contains a real store. */
export const hasRealStore = (stores = []) => stores.some(isRealStore);

/**
 * Returns whether the pre-trial acquisition card should be shown. Active and
 * expired trial states are handled separately by the sidebar.
 */
export const shouldShowStartTrialCard = (daysLeft, stores = []) =>
  daysLeft === -1 && !hasRealStore(stores);
